import * as React from 'react';

import { useStrings } from 'src/providers';

import { ReactComponent as BackArrow } from 'src/images/chevron-arrow.svg';

interface IFAQBackButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

function Button(props: IFAQBackButtonProps, ref: React.ForwardedRef<HTMLButtonElement>) {
  const { onClick } = props;
  const { faqBackButton } = useStrings();

  return (
    <button
      className='button-reset faq-tab__header__back-button'
      id='switch-plandata'
      onClick={onClick}
      ref={ref}
    >
      <BackArrow className='faq-tab__header__back-button__arrow' data-test='faq-return-arrow' />
      <div className='faq-tab__header__back-button__text'>{faqBackButton}</div>
    </button>
  );
}


export const BackButton = React.forwardRef(Button);
